import { Component, Vue } from 'vue-property-decorator';
import Inspirations from '../../shared/Inspirations/inspirations.vue';
import * as T_T from 'cryface';
import { AxiosPromise } from '../../utils/axios.promise';
import { CommonConfig } from '../../configs/config.common';
import { NoticeConfig } from 'iview';
import { ESessions } from '../../models/sessions';

@Component({
   components: {
      Inspirations,
   }
})
export default class LoginPage extends Vue {
   public title: string = 'LoginPage';
   public isLogining: boolean = false;

   public commonConfig = new CommonConfig();

   public form = {
      username: '',
      password: '',
   };

   public ruleValidate = {
      username: [
         { required: true, message: 'The username cannot be empty', trigger: 'blur' }
      ],
      password: [
         { required: true, message: 'The password cannot be empty', trigger: 'blur' }
      ],
   };

   public created() {
   }

   public async handleLogin(name: any) {
      this.isLogining = true;
      const _refs: any = this.$refs;
      _refs[name].validate((valid: any) => {
         if (valid) {
            this.onValidateSuccess();
         } else {
            this.onValidateFailed();
         }
      });
   }

   public async onValidateSuccess() {
      await this.login();
      this.$router.push('/skittles');
      this.isLogining = false;
   }

   public async onValidateFailed() {
      this.isLogining = false;
   }

   public async login() {
      const requestForm = new FormData();
      // requestForm.set('email', 'toeyxiaoj@vip.qq.com');
      // requestForm.set('passwd', '88888888');
      requestForm.set('email', this.form.username);
      requestForm.set('passwd', this.form.password);
      requestForm.set('app', 'A');
      // const apiHost = 'http://192.168.0.125:9527';
      const authoreyHost = this.commonConfig.authoreyHost;
      try {
         const result = await AxiosPromise.postForm(`${authoreyHost}/auth/login`, requestForm);
         if (T_T.simpleDetect(result.data)) {
            if (result.data.errorCode === 200) {
               const userInfo = result.data.data;
               const _this: any = this;
               const browserStore = _this.$browserStore;
               browserStore.setSession(ESessions.UserInfo, JSON.stringify(userInfo));
               if (T_T.simpleDetect(userInfo)) {
                  const userId = userInfo.id;
                  const menuListFetched = await AxiosPromise.get(`${authoreyHost}/web/radar/meunlist?yuId=${userId}`);
                  if (menuListFetched.errorCode === 200) {
                     this.getAvatar(this.commonConfig.microServHostAvatar, userInfo);
                     this.$store.commit('menuListGottem', menuListFetched.data);
                  }
                  this.$store.commit('authenticated', userInfo);
                  const successNoticeConfig: NoticeConfig = {
                     title: 'Login Succeed',
                     desc: 'Welcome to RIFO-Radar.'
                  };
                  this.$Notice.success(
                     successNoticeConfig
                  );
               }
            } else {
               alert('Invalid Username Or Password.');
            }
         }
      } catch (e) { alert('Please Check Internet Connections.'); console.error(e); }
   }

   public async getAvatar(uri: string, userInfo: any) {
      const avatarBody = {
         id: userInfo.xPartnerId
      };
      try {
         const avatarFetched = await AxiosPromise.postJson(uri, avatarBody);
         if (T_T.simpleDetect(avatarFetched.data)) {
            if (T_T.simpleDetect(avatarFetched.data.data)) {
               this.$store.commit('avatarGotten', avatarFetched.data.data.imageUrl);
            }
         }
      } catch (e) { }
   }
}
